import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@gemini/core';
import { OfferCardProvider } from '@/providers/OfferCardProvider';
import { OfferCardMobile } from './OfferCardMobile';
export function OfferCardsMobile({ offerCards }) {
    const generateCardsLayout = () => {
        return offerCards.map((offerCard) => (_jsx(OfferCardProvider, { offerCard: offerCard, children: _jsx(OfferCardMobile, {}) }, offerCard.id)));
    };
    return (_jsx(Box, { width: "100%", children: _jsx(Box, { testId: "offer-cards-mobile", display: "flex", flexDirection: "column", gap: "spacing.16", marginTop: "spacing.24", marginBottom: "spacing.40", children: generateCardsLayout() }) }));
}
